export default __webpack_public_path__ + "static/media/csd-logo.cff6eb2f.svg";